const Main = props => {
    return <div class="main"><h1>Welcome</h1>
    Navigate above to view the most active stocks and find details for each stock.</div>
}

export default Main;